import { render } from "./WirepasLocationsView.vue?vue&type=template&id=34aea8c3&scoped=true&ts=true"
import script from "./WirepasLocationsView.vue?vue&type=script&lang=ts"
export * from "./WirepasLocationsView.vue?vue&type=script&lang=ts"

import "./WirepasLocationsView.vue?vue&type=style&index=0&id=34aea8c3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34aea8c3"]])

export default __exports__